// extracted by mini-css-extract-plugin
export default {"productcard":"YC","productimage":"ZC","username":"aE","multiBagName":"bE","productinfo":"cE","productinfoinner":"eE","productname":"fE","productsubheader":"gE","productdescription":"hE","productnumbers":"iE","productnumberstitle":"jE","productnumbersitem":"kE","number":"lE","numbertext":"mE","tabs":"nE","benefitsblock":"oE","benefit":"pE","benefitname":"qE","benefitdescription":"rE","ingredientsblock":"sE","tipsblock":"tE","mobileonly":"uE"};
    if(module.hot) {
      // 1714422956205
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  